import React from 'react';
import Typography from '@mui/material/Typography';
import { getTypographyColorProps } from './getTypographyColorProps';
import { renderHeadingTextWithEmphasis } from './renderHeadingTextWithEmphasis';

const Heading6 = (props) => {
  const { color, children, ...rest } = props;
  const { typographyColor, colorStyle } = getTypographyColorProps(color);
  const formattedChildren = renderHeadingTextWithEmphasis(children, color);
  return (
    <Typography
      {...rest}
      component='h6'
      color={typographyColor}
      sx={[{
        fontSize: '20px',
        fontWeight: '700',
        lineHeight: '25px'
      }, colorStyle, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
      {formattedChildren}
    </Typography>
  );
};

export default Heading6;
